"use client";

import { useEffect, useRef, useState } from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { ArrowRight } from "lucide-react";
interface BarData {
  label: string;
  value: number;
  color: string;
}
export default function OurStoryAndImpact() {
  const headlineRef = useRevealOnScroll<HTMLHeadingElement>({
    threshold: 0.3
  });
  const cardRef = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const chartRef = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const [hoveredBar, setHoveredBar] = useState<number | null>(null);
  const [tooltipPos, setTooltipPos] = useState({
    x: 0,
    y: 0
  });
  const barData: BarData[] = [{
    label: "Students Served",
    value: 87,
    color: "hsl(190,80%,45%)"
  }, {
    label: "Academic Growth",
    value: 92,
    color: "hsl(170,90%,40%)"
  }, {
    label: "Behavioral Improvement",
    value: 78,
    color: "hsl(35,70%,55%)"
  }, {
    label: "Parent Satisfaction",
    value: 95,
    color: "hsl(190,78%,50%)"
  }];
  const handleMouseEnter = (index: number, e: React.MouseEvent<HTMLDivElement>) => {
    setHoveredBar(index);
    const rect = e.currentTarget.getBoundingClientRect();
    setTooltipPos({
      x: rect.left + rect.width / 2,
      y: rect.top - 10
    });
  };
  const handleMouseLeave = () => {
    setHoveredBar(null);
  };
  return <section className="relative w-full bg-light-background py-16 px-4 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-7xl">
        {}
        <h2 ref={headlineRef.ref} className={`text-4xl sm:text-5xl lg:text-6xl font-display font-bold text-foreground-light text-center mb-12 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${headlineRef.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          Our Story & Impact
        </h2>

        {}
        <div ref={cardRef.ref} className={`mb-16 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${cardRef.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <Card className="shadow-soft max-w-4xl mx-auto">
            <CardContent className="pt-6">
              <p className="text-base sm:text-lg text-foreground-light leading-relaxed text-center">
                Founded with a mission to serve K‑12 students with diverse learning needs, FIRST CLASS RESOURCES, LLC
                leverages cutting‑edge technology and AI‑driven assessment tools to deliver personalized instruction
                across English language arts, science, social studies, and behavioral support. Our experienced team of
                special education professionals is committed to fostering inclusive, measurable educational outcomes
                that empower every learner to thrive.
              </p>
            </CardContent>
          </Card>
        </div>

        {}
        <div ref={chartRef.ref} className={`relative bg-dark-background/30 rounded-lg shadow-medium p-8 sm:p-12 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${chartRef.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <h3 className="text-2xl sm:text-3xl font-display font-semibold text-foreground-light mb-8 text-center">
            Measurable Outcomes
          </h3>

          <div className="space-y-6 max-w-3xl mx-auto" data-index={0}>
            {barData.map((bar, i) => <div key={i} className="relative" data-index={i}>
                <div className="flex justify-between items-center mb-2">
                  <span className="text-sm font-medium text-foreground-light">{bar.label}</span>
                  <span className="text-sm font-semibold text-foreground-light">{bar.value}%</span>
                </div>
                <div className="w-full bg-muted rounded-md h-8 overflow-hidden relative">
                  <div className={`h-full rounded-md transition-all duration-[var(--duration-slow)] ease-[var(--ease-out-back)] cursor-pointer hover:brightness-110 ${chartRef.isVisible ? "" : "w-0"}`} style={{
                width: chartRef.isVisible ? `${bar.value}%` : "0%",
                backgroundColor: bar.color,
                transitionDelay: `${i * 100}ms`
              }} onMouseEnter={e => handleMouseEnter(i, e)} onMouseLeave={handleMouseLeave} />
                </div>

                {}
                {hoveredBar === i && <div className="fixed z-50 bg-primary text-foreground-primary px-3 py-2 rounded-md text-xs font-semibold shadow-strong pointer-events-none transform -translate-x-1/2 -translate-y-full" style={{
              left: `${tooltipPos.x}px`,
              top: `${tooltipPos.y}px`
            }}>
                    {bar.value}% Achieved
                  </div>}
              </div>)}
          </div>

          {}
          <div className="mt-12 text-center">
            <Link to="/ResourcesPage" className="inline-flex items-center gap-2 text-accent font-semibold text-base hover:scale-[1.02] hover:shadow-medium transition-all duration-[var(--duration-fast)] ease-[var(--ease-spring)] focus-ring px-6 py-3 rounded-md bg-accent/10">
              Read Full Impact Report
              <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </div>
    </section>;
}